(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zwei-spalten"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.category-sidebar__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !expanded);
      const submenu = btn.parentElement.nextElementSibling;
      if (submenu) { submenu.hidden = expanded; }
    });
  });

  var sidebarToggleBtn = document.querySelector('.two-column-sidebar-toggle__btn');
  var sidebar = document.querySelector('.two-column-sidebar');

  if (sidebarToggleBtn && sidebar) {
    var defaultLabel = sidebarToggleBtn.dataset.defaultLabel || 'Kategorien anzeigen';
    sidebarToggleBtn.addEventListener('click', function () {
      sidebar.classList.toggle('is-open');
      sidebarToggleBtn.textContent = sidebar.classList.contains('is-open') ? 'Kategorien ausblenden' : defaultLabel;
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
